import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { COMPANY } from "@/lib/site";
import ThemeToggle from "@/components/ThemeToggle";

export default function Account() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const signOut = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen royal-radial grain relative flex items-center justify-center px-4" data-testid="account-page">
      <ThemeToggle className="absolute top-6 right-6 z-20" />
      <div className="relative z-10 w-full max-w-md surface-panel border border-emerald-900/60 rounded-2xl p-8 animate-fade-up">
        <img src={COMPANY.logo} alt="crest" className="w-16 h-16 object-contain mb-6" />
        <p className="text-[11px] tracking-[0.3em] uppercase text-gold mb-2">Your account</p>
        <h1 className="font-display text-3xl text-emerald-50 mb-6">Welcome{user?.name ? `, ${user.name}` : ""}</h1>
        <div className="flex items-center gap-3 surface-input border border-emerald-900/60 rounded-xl p-4 mb-6">
          <UserRound className="w-5 h-5 text-emerald-400" />
          <div className="min-w-0">
            <div className="text-emerald-50 truncate" data-testid="account-email">{user?.email}</div>
            <div className="text-xs text-slate-500 capitalize" data-testid="account-role">{user?.role} account</div>
          </div>
        </div>
        <p className="text-sm text-slate-400 mb-8">
          Your account is active. The executive dashboard is reserved for authorized administrators.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link to="/" data-testid="account-back-to-site"
            className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to site
          </Link>
          <button onClick={signOut} data-testid="account-logout"
            className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-full border border-gold/40 text-gold hover:bg-gold/10 transition-colors">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
